import 'moment/locale/es'
import moment from 'moment-timezone'
import React, { useEffect } from 'react'
import { Card, Carousel } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useCurrentUser } from '../../hooks/useCurrentUser'
import { isVideo } from '../../lib/files'
import VPFBadge from '../VPFBadge/VPFBadge'
import styles from './feed.scss'

export default function UpcomingFeed({ event, onVPFClick }) {
  const { t } = useTranslation()
  const { locale } = useCurrentUser()
  const startMoment = moment(event?.event_start_date).tz(moment.tz.guess())
  const todayMoment = moment()
    .hour(startMoment.hour())
    .minute(startMoment.minute())
    .second(0)
  const status =
    startMoment.diff(moment()) < 0
      ? todayMoment.diff(moment()) < 0
        ? t('feed.in_progress')
        : t('feed.starting_at', {
            time: todayMoment.format(t('config.time_format')),
          })
      : `${startMoment.format(t('config.date_format'))} · ${startMoment.format(
          t('config.time_format'),
        )}`

  useEffect(() => {
    moment.locale(locale)
  }, [locale])

  return (
    <Link to={`/events/${event?.slug ?? event?.id}`}>
      <Card className="m-0 shadow-none upcoming">
        {(!!event?.media_attachments?.length && (
          <Carousel
            controls={event?.media_attachments?.length > 1}
            indicators={event?.media_attachments?.length > 1}
          >
            {event?.media_attachments?.map(imgLink => {
              return (
                <Carousel.Item
                  key={`${event?.id} ${imgLink.id}`}
                  className="card-img-top"
                >
                  {(isVideo(imgLink) && (
                    <video
                      className="card-img-top"
                      autoPlay
                      muted
                      loop
                      controls
                      poster={imgLink.thumbnail_url}
                      src={imgLink.direct_upload_url}
                    />
                  )) || (
                    <Card.Img
                      variant="top"
                      src={
                        imgLink.resized_image_url ?? imgLink.direct_upload_url
                      }
                      alt={t('event.media_post_video')}
                    />
                  )}
                </Carousel.Item>
              )
            })}
          </Carousel>
        )) || (
          <Card.Img
            variant="top"
            src={
              locale === 'es'
                ? '/images/draft-media-placeholder-ES.png'
                : '/images/draft-media-placeholder-EN.png'
            }
            alt={t('event.media_post_thumbnail')}
          />
        )}
        <Card.Body className="py-1 px-2 card_body">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-1 mb-1">
            <Card.Text className="time mb-0" as="span">
              {status}
            </Card.Text>
            <VPFBadge event={event} stopPropagation onVPFClick={onVPFClick} />
          </div>
          <Card.Title className="card_title">{event.title}</Card.Title>
        </Card.Body>
      </Card>
    </Link>
  )
}
